"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(theme) {
  return {
    noScroll: "\n            overflow-y: hidden;\n            overflow-x: hidden;\n        ",
    fx: "\n            filter: ".concat(theme.overlayFilter, ";\n        ")
  };
}